import { gql, useMutation } from '@apollo/client';

import { OdProtosWebData_RecordedFeature } from '../../../__generated__/athenaGlobalTypes';
import {
  SubmitSSVAByRecordedFeature,
  SubmitSSVAByRecordedFeatureVariables,
} from '../../../graphql/athena/mutations/__generated__/SubmitSSVAByRecordedFeature';
import { VirtualAssessmentQuery } from '../queries/useVirtualAssessmentData';

const SUBMIT_SSVA_BY_RECORDED_FEATURE = gql`
  mutation SubmitSSVAByRecordedFeature(
    $sellerInputUUID: String!
    $recordedFeature: OdProtosWebData_RecordedFeature!
  ) {
    sellDirect {
      submitSSVARecordedFeature(
        input: {
          recordedFeature: $recordedFeature
          lead: { source: { type: RECEPTION, id: $sellerInputUUID } }
        }
      ) {
        virtualAssessment {
          id
          ssvaRecordingsSubmitted
          ssvaQuestionnaireSubmitted
          ssvaInteriorRecordingsSubmitted
          ssvaFrontyardRecordingsSubmitted
          ssvaBackyardRecordingsSubmitted
          ssvaRecordings {
            id
            recordedFeature
            s3Directory
            fileName
          }
        }
      }
    }
  }
`;

/** Make GraphQL request to submit SSVA by RecordedFeature */
export const useSubmitSSVAByRecordedFeature = (sellerInputUUID: string) => {
  const [submitSSVAWebMutation, submitSSVAWebMutationResp] = useMutation<
    SubmitSSVAByRecordedFeature,
    SubmitSSVAByRecordedFeatureVariables
  >(SUBMIT_SSVA_BY_RECORDED_FEATURE, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
    refetchQueries: [VirtualAssessmentQuery],
  });

  const submitSSVAByRecordedFeature = (feature: OdProtosWebData_RecordedFeature) => {
    return submitSSVAWebMutation({
      variables: { sellerInputUUID, recordedFeature: feature },
    }).then(({ data }) => {
      if (!data?.sellDirect.submitSSVARecordedFeature) return;
      return true;
    });
  };

  return {
    submitSSVAByRecordedFeature,
    data: submitSSVAWebMutationResp.data,
    loading: submitSSVAWebMutationResp.loading,
    error: submitSSVAWebMutationResp.error,
  };
};
